import { useEffect } from 'react';

import { useSynchronizedSelection } from '../../core/components/shared-chart-interactions/hooks/useSynchronizedSelection.js';

/**
 * Custom hook that resets the synchronized selection state when the component unmounts.
 * This ensures that chart selection state is properly cleaned up when the component is removed.
 */
export const useResetSelectionOnUnmount = () => {
  const { resetSelectionState } = useSynchronizedSelection();

  useEffect(() => {
    return () => {
      resetSelectionState?.();
    };
  }, []);
};
